import { generateReducer } from "../generators/generator.reducer";
export var applicationFiltersReducer = generateReducer({
    entity: "ApplicationFilter",
    reducerKey: "applicationFilters",
    basePathEntity: "application-filters",
});
